import React from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Divider,
} from "@mui/material";

const AppointmentPrintPage = () => {
  const { state } = useLocation();

  if (!state) {
    return <Typography variant="h6" align="center">No appointment data found.</Typography>;
  }

  const { appointment, pain_areas } = state;
  const guest = appointment.guest;
  const doctor = appointment.doctor;

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box
      sx={{
        maxWidth: 900,
        margin: "30px auto",
        bgcolor: "#fff",
        p: 4,
        borderRadius: 2,
        boxShadow: 3,
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Box textAlign="center" mb={3}>
        <img src="/logo.png" alt="Logo" style={{ height: "70px", marginBottom: 8 }} />
        <Typography variant="h5" fontWeight="bold">GoPT India Osteopathy and Physiotherapy</Typography>
        <Typography>BR 84, Sector 116, Opposite Mahagun Mirabella, Noida, 201303</Typography>
        <Typography>Phone: 7906545453 | Mobile: 9711699992</Typography>
        <Typography>Email: info@goptindia.com | Web: www.goptindia.com</Typography>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Appointment Info */}
      <TableSection
        title="Appointment Details"
        rows={[
          ["Appointment Date", formatDate(appointment.date)],
          ["Time", appointment.time],
          ["Doctor", doctor.fname],
          ["Patient", guest.name],
        ]}
      />

      {/* Acknowledgement & Status */}
      <TableSection
        title="Acknowledgement"
        rows={[
          ["Acknowledgement No", appointment.acknowledgement_no || "N/A"],
          ["Status", capitalize(appointment.status)],
        ]}
      />

      {/* Pain Area */}
      <TableSection
        title="Pain Area"
        rows={[
          ["Pain Area", pain_areas?.group_name || "N/A"],
        ]}
      />

      {/* Notes */}
      <Paper elevation={1} sx={{ p: 2, bgcolor: "#f1f8ff", borderLeft: "5px solid #1976d2", mb: 2 }}>
        <Typography variant="body1"><strong>Note:</strong> Your appointment has been successfully booked.</Typography>
      </Paper>

      {appointment.is_overbooked && (
        <Paper elevation={1} sx={{ p: 2, bgcolor: "#ffeaea", borderLeft: "5px solid #e53935", mb: 2 }}>
          <Typography variant="body1" color="error">
            <strong>Important:</strong> यह एक अतिरिक्त (overbooked) अपॉइंटमेंट है। कृपया समय से 30 मिनट पहले पहुंचें। धन्यवाद!
          </Typography>
        </Paper>
      )}

      <Box textAlign="center" mt={4}>
        <Button onClick={handlePrint} variant="contained" sx={{ bgcolor: "#007bff", px: 4, py: 1.5 }}>
          Download / Print
        </Button>
      </Box>
    </Box>
  );
};

// Reusable Table Section
const TableSection = ({ title, rows }) => (
  <Box mb={3}>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{title}</Typography>
    <TableContainer component={Paper} sx={{ mb: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            {rows[0].map((_, idx) => (
              <TableCell key={idx} sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>
                {rows[0][idx]}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {rows.map(row => (
              <TableCell key={row[0]}>{row[1]}</TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

// Utils
const formatDate = (dateString) => {
  const options = { day: "2-digit", month: "long", year: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const capitalize = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

export default AppointmentPrintPage;
